import { Component, inject } from '@angular/core';
import { LabelComponent } from '../../form/label/lable';
import { CheckboxComponent } from '../../form/input/checkbox';
import { ButtonComponent } from '../../ui/button/button';
import { InputFieldComponent } from '../../form/input/input-field';
import { Router, RouterModule } from '@angular/router';
import { AbstractControl, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { properEmailValidator } from '../../../shared/validators/email.validator';

@Component({
  selector: 'app-reset-password-form',
  imports: [
    LabelComponent,
    ButtonComponent,
    InputFieldComponent,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './reset-password-form.html'
})
export class ResetPasswordForm {

  private fb = inject(FormBuilder);
  isLoading = false;
  success = false;

  constructor(private authService: AuthService, private toastr: ToastrService, private router: Router) { }

  form = this.fb.group({
    email: ['', [Validators.required, properEmailValidator]],
  });

  get f() {
    return this.form.controls;
  }

  fieldError(name: keyof typeof this.form.controls): string {
    const ctrl = this.f[name] as AbstractControl;

    if (!ctrl.invalid || !(ctrl.touched || ctrl.dirty)) return '';

    const e = ctrl.errors!;

    if (e['required'] || e['requiredTrue']) return this.requiredMsg(name);
    if (e['minlength'])
      return `Minimum ${e['minlength'].requiredLength} characters required`;
    if (e['email']) return 'Invalid email format';
    if (e['pattern']) return 'Must contain at least 1 uppercase letter and 1 number';

    return 'Invalid field';
  }

  private requiredMsg(name: string): string {
    const map: Record<string, string> = {
      password: 'Password is required',
    };
    return map[name] ?? 'This field is required';
  }

  onSubmit() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsTouched();
      ctrl.markAsDirty();
    });

    if (this.form.invalid) return;

    this.isLoading = true;

    const { email } = this.form.getRawValue();

    this.authService.forgotPassword({
      email: email!.trim(),
    })
      .subscribe(
        (res: any) => {
          console.log('Success:', res);
          this.isLoading = false;
          this.success = true;
          this.toastr.success(res?.message || 'Reset link sent successfully!');
          this.form.reset();
        },
        (err: any) => {
          console.log('Error:', err);
          this.isLoading = false;

          this.toastr.error(
            err?.error?.message || 'Something went wrong!',
            'Error'
          );
        }
      );
  }

}
